module.exports = __webpack_public_path__ + "img/LongImage2-compressor.ac1f844a.jpg";